export const personParents = ['father', 'mother'] as const;

export type PersonParent = (typeof personParents)[number];

export const NATURAL_PERSON_NAME_MAX_LENGTH = 20;
